let initialState = {
  sessionId: null,
  sessionData: null,
  profileToken: null,
  apiKey : null,
  initSessionOptions : null,
  ipAddress: ""
},
  state = initialState,
  shadowRoot = null;

export const setSessionId = (sessionId) =>
(state = {
  ...state,
  sessionId,
});

export const getSessionId = () => state.sessionId;

export const getStoreData = () => state;

export const setSessionData = (sessionData, reset = false) => {
  if (reset) {
    state = {
      ...state,
      sessionData,
    };
  } else
    state = {
      ...state,
      sessionData: {
        ...state.sessionData,
        ...sessionData,
      },
    };
};

export const getSessionData = () => state.sessionData;

export const resetStore = () => {
  state = initialState;
};

export const setProfileToken = (profileToken) =>
(state = {
  ...state,
  profileToken,
});

export const getProfileToken = () => state.profileToken;

export const setShadowRoot = (root)=>{
  shadowRoot = root;
}

export const getShadowRoot = ()=> {return shadowRoot ?? document.getElementById("identity-container").shadowRoot};

export const setApiKey = (apiKey)=>(state = {
  ...state,
  apiKey,
});

export const getApiKey = ()=>state.apiKey;

export const setinitSessionOptions = (initSessionOptions)=>(state = {
  ...state,
  initSessionOptions,
});

export const getinitSessionOptions = ()=>state.initSessionOptions;

export const setshowClose = (showClose) =>
(state = {
  ...state,
  showClose,
});

export const getshowClose = ()=>state.showClose;

export const setIsIdentityCalled = (IsIdentityCalled) =>
(state = {
  ...state,
  IsIdentityCalled,
});

export const getIsIdentityCalled = ()=>state.IsIdentityCalled;

export const setElement = (element) =>
(state = {
  ...state,
  element,
});

export const getElement = ()=>state.element;

export const setEventType = (eventType) =>
(state = {
  ...state,
  eventType,
});

export const getEventType = ()=>state.eventType;

export const getPlatform = ()=>state.platform;

export const setPlatform = (platform) =>
(state = {
  ...state,
  platform,
});

export const setinitBillingAddr = (initBillingAddr)=>(state = {
  ...state,
  initBillingAddr,
});

export const getinitBillingAddr = ()=>state.initBillingAddr;

export const setallowEditing = (allowEditing)=>(state = {
  ...state,
  allowEditing,
});

export const getallowEditing = ()=>state.allowEditing;

export const setIpAddress = (ipAddress) =>
(state = {
  ...state,
  ipAddress,
});

export const getIpAddress = () => state.ipAddress;

export const setBrowserDetails = (browserDetails) =>
(state = {
  ...state,
  browserDetails,
});

export const getBrowserDetails = () => state.browserDetails;

export const setLiveSelfiDetails = (liveSelfiDetails) =>
(state = {
  ...state,
  liveSelfiDetails,
})

export const getLiveSelfiDetails = () => state.liveSelfiDetails;

export const setMobileVerificationConsent = (mobileVerificationConsent) =>
(state = {
  ...state,
  mobileVerificationConsent,
});

export const getMobileVerificationConsent = () => state.mobileVerificationConsent;

export const setUploadDocumentConsent= (uploadDocumentConsent) =>
(state = {
  ...state,
  uploadDocumentConsent
})

export const getUploadDocumentConsent = () => state.uploadDocumentConsent;

export const setDocumentVerificationStarted = (started) =>
(state = {
  ...state,
  documentVerificationStarted: started,
});

export const getDocumentVerificationStarted = () => state.documentVerificationStarted;

export const setFlowOriginatedFromWeb = (originatedFromWeb) =>
(state = {
  ...state,
  flowOriginatedFromWeb: originatedFromWeb,
});

export const getFlowOriginatedFromWeb = () => state.flowOriginatedFromWeb;

export const setSdkOrigin = (sdkOrigin) =>
(state = {
  ...state,
  sdkOrigin,
});

export const getSdkOrigin = ()=>state.sdkOrigin;
export const setElementType = (elementVerificationType) =>
(state = {
  ...state,
  elementVerificationType,
});

export const getElementType = ()=>state.elementVerificationType;

export const setPageType = (pageVerificationType) =>
(state = {
  ...state,
  pageVerificationType,
});

export const getPageType = ()=>state.pageVerificationType;

export const setIsBasicConfirimDOB = (verifyDob) =>
(state = {
  ...state,
  verifyDob,
});

export const getIsBasicConfirimDOB = ()=>state.verifyDob;

export const setshowSignIn = (showSignIn) =>
(state = {
  ...state,
  showSignIn,
});

export const getshowSignIn = ()=>state.showSignIn;

export const setsignInButtonText = (signInButtonText) =>
(state = {
  ...state,
  signInButtonText,
});

export const getsignInButtonText = ()=>state.signInButtonText;


export const setallowSkip= (allowSkip) =>
(state = {
  ...state,
  allowSkip,
});

export const getallowSkip = ()=>state.allowSkip;

export const setbtnVerifyColor= (btnVerifyColor) =>
(state = {
  ...state,
  btnVerifyColor,
});

export const getbtnVerifyColor = ()=>state.btnVerifyColor;

export const setpageVerificationElement= (pageVerificationElement) =>
(state = {
  ...state,
  pageVerificationElement,
});

export const getpageVerificationElement = ()=>state.pageVerificationElement;

export const setMustVerifyAge= (mustVerifyAge) =>
(state = {
  ...state,
  mustVerifyAge,
});

export const getMustVerifyAge = ()=>state.mustVerifyAge;

export const setKeepSession = (keepSession) =>
(state = {
  ...state,
  keepSession,
});

export const getKeepSession = ()=>state.keepSession;
